import React, { useState, useEffect } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {

    let navigate = useNavigate();
    const [UserName, setUserName] = useState("");
    const [Password, setPassword] = useState("");
    const [Remember, setRemember] = useState(false);
    const [ShowLoader, setShowLoader] = useState(false);

    //--> تا وقتی معلوم نشده کاربر از قبل وارد شده یا نه، فرم نشان داده
    //--> نمی شود؛ وگرنه فرم یک لحظه می آید و بعد صفحه عوض می شود
    const [Checking, setChecking] = useState(true);

    //--> بعد از ورود موفق، هم اینجا و هم در بررسی خودکار همین ها لازم است
    const SaveUser = (data) => {
        localStorage.setItem("FirstName", data.firstName);
        localStorage.setItem("LastName", data.lastName);
        localStorage.setItem("Permission", data.permission);
        localStorage.setItem("UserId", data.id);
    }

    //--> اگر کوکی هنوز معتبر است، اصلا فرم ورود لازم نیست.
    //--> پرسش از سرور است نه از localStorage: آنچه در مرورگر مانده نام و
    //--> نقش است، نه سند یک نشست معتبر.
    useEffect(() => {
        axios({
            method: "Get",
            url: General.ApiRoute() + "/User/Current",
            headers: { ApiKey: process.env.REACT_APP_APIKEY },
            withCredentials: true
        })
            .then(function (res) {
                if (res.data && res.data.id && res.data.id !== General.GuidEmpty()) {
                    SaveUser(res.data);
                    //--> replace تا دکمه بازگشت کاربر را به صفحه ورود برنگرداند
                    navigate("/Home", { replace: true });
                    return;
                }
                setChecking(false);
            })
            .catch(() => {
                //--> ۴۰۱ یعنی نشستی در کار نیست. حالت عادی است، نه خطا.
                setChecking(false);
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const DoLogin = () => {
        setShowLoader(true);
        if (UserName === "") {
            General.ShowMsg(Enum.MsgType.error, "لطفا نام کاربری را وارد نمایید");
            setShowLoader(false);
            return;
        }
        if (Password === "") {
            General.ShowMsg(Enum.MsgType.error, "لطفاً کلمه عبور را مشخص نمایید");
            setShowLoader(false);
            return;
        }
        var RequestOption = {
            method: 'post',
            url: General.ApiRoute() + "/User/Login",
            data: {
                "UserName": UserName,
                "Password": Password,
                "FirstName": ".",
                "LastName": ".",
                "LoginError": ".",
                "Remember": Remember
            },
            withCredentials: true
        }

        axios(RequestOption)
            .then(function (res) {
                if (res.data.loginError === "OK") {
                    SaveUser(res.data);
                    navigate("/Home");
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, "اطلاعات وارد شده مورد تایید نمی باشد");
                    setShowLoader(false);
                }

            })
            .catch(error => {
                General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                setShowLoader(false);
            })

    }

    if (Checking) {
        return (
            <rsuite.Container className='h-100vh'>
                <rsuite.Content>
                    <rsuite.FlexboxGrid justify='center' align='middle' className='h100vh'>
                        <rsuite.Loader content="لطفاً منتظر بمانید..." />
                    </rsuite.FlexboxGrid>
                </rsuite.Content>
            </rsuite.Container>
        );
    }

    return (
        <rsuite.Container className='h-100vh'>
            <rsuite.Content>
                <rsuite.FlexboxGrid justify='center' align='middle' className='h100vh'>
                    <rsuite.FlexboxGrid.Item as={rsuite.Col} md={10} xs={24} >

                        <rsuite.Panel className='bg-white w-100'>
                            <div align="center">
                                <img src="../../../images/Logo.png" className='w-50 m-3' alt="TicketLAB" />
                            </div>
                            <div>
                                <label>نــام کاربری</label>
                                {/* اینتر همان کاری را می کند که دکمه؛ روی هر دو
                                    جعبه، چون کاربر از هرکدام ممکن است اینتر بزند */}
                                <rsuite.Input
                                    type="text"
                                    value={UserName}
                                    onChange={value => setUserName(value)}
                                    onPressEnter={DoLogin}
                                    required
                                />
                            </div>
                            <div className='mt-3'>
                                <label>کلمه عبــور</label>
                                <rsuite.Input
                                    type="password"
                                    value={Password}
                                    onChange={value => setPassword(value)}
                                    onPressEnter={DoLogin}
                                    required
                                />
                            </div>
                            <div className='mt-3'>
                                {/* هیچ نام کاربری و رمزی ذخیره نمی شود؛ فقط
                                    همان کوکی همیشگی تاریخ انقضا می گیرد تا با
                                    بستن مرورگر از بین نرود */}
                                <rsuite.Checkbox
                                    checked={Remember}
                                    onChange={(value, checked) => setRemember(checked)}
                                >
                                    مرا به خاطر بسپار
                                </rsuite.Checkbox>
                            </div>
                            <div align="left">
                                {
                                    !ShowLoader ?
                                        <rsuite.Button appearance='primary' className='mt-4' onClick={DoLogin} >ورود به ناحیه کاربری</rsuite.Button>
                                        :
                                        <rsuite.Button appearance='primary' disabled className='mt-4' ><rsuite.Loader />لطفاً منتظر بمانید</rsuite.Button>
                                }
                            </div>

                        </rsuite.Panel>
                    </rsuite.FlexboxGrid.Item>
                </rsuite.FlexboxGrid>
            </rsuite.Content>
        </rsuite.Container>
    )
}

export default Login;
